import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import SVGIcon from './ExitIcon';

const Button = styled.button`
  border: none;
  background: transparent;
  color: #064C70;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  text-decoration: none;

  &:hover {
    div { background: #064C70; }
    .icon { fill: #064C70; }
  }
`;

const Link = Button.withComponent('a');

const Label = styled.div`
  font-family: ${(props) => props.theme.font};
  background: #F9A303;
  border: 2px solid #FFFFFF;
  border-radius: 3px;
  color: white;
  font-size: 1.25rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
`;
const PositionWrapper = styled.div`
  height: 10px;
  width: 10px;
  overflow: visible;

  ${(props) => (props.top && props.left && css`
    position: absolute;
    top: ${`${props.top}%`};
    left: ${`${props.left}%`};
  `)};

  ${(props) => (props.center && css`
    position: fixed;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
  `)};
`;


class SwitchViewButton extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  renderChildren = () => {
    const { isExit, label } = this.props;
    return [
      (isExit && <Label key="label">{label}</Label>),
      <SVGIcon up={!isExit} key="icon" />,
      (!isExit && <Label key="label">{label}</Label>),
    ];
  }

  render() {
    const { isExit, label, onClick, linkTo, ...rest } = this.props;

    return (
      <PositionWrapper {...rest}>
        {linkTo ? (
          <Link href={linkTo} title={label}>
            {this.renderChildren()}
          </Link>
        ) : (
          <Button onClick={onClick}>
            {this.renderChildren()}
          </Button>
        )}
      </PositionWrapper>
    );
  }
}

SwitchViewButton.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  isExit: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  linkTo: PropTypes.string,
};

SwitchViewButton.defaultProps = {
  height: 2.5,
  isExit: false,
  width: 2,
  onClick: () => {},
  linkTo: null,
};

export default SwitchViewButton;



// WEBPACK FOOTER //
// ./src/components/SwitchViewButton/Button.js